import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthorizationState } from '@modules/authorization/store';

export const selectAuthorizationState = createFeatureSelector<AuthorizationState>('authorization');

const selectAuth = createSelector(selectAuthorizationState, (s) => s.auth);

export const selectAuthTokens = createSelector(selectAuth, (s) => s.entity);
export const selectAccessTokens = createSelector(selectAuth, (s) => s.entity?.accessToken);
export const selectRefreshTokens = createSelector(selectAuth, (s) => s.entity?.refreshToken);
export const selectIsAuthenticated = createSelector(selectAuth, (s) => Boolean(s.entity?.accessToken && s.entity?.refreshToken));
